// @ts-strict-ignore
import {Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {CameraResolutionType, DisplayMode, WebCameraView} from "@models";
import {EventEmitterService} from "@event-emitter";
import {SimCameraService} from "@services";
import {LiveStreamCameraLayoutOptions} from "../../../types/camera-layout-options";

@Component({
	selector: "sim-camera-viewer",
	templateUrl: "./camera-viewer.component.html",
	styleUrls: ["./camera-viewer.component.scss"],
	standalone: false,
})
export class CameraViewerComponent implements OnInit, OnChanges {
	@Input()
	public cameraId: string;

	public camera: WebCameraView = null;

	public options: LiveStreamCameraLayoutOptions = <LiveStreamCameraLayoutOptions>{
		displayMode: DisplayMode.Auto,
		preferredStream: CameraResolutionType.RecordingWindowFull,
		preferredFullscreenStream: CameraResolutionType.RecordingWindowFull,
	};

	constructor(
		private _simCameraService: SimCameraService,
		private _emitterService: EventEmitterService,
	) {}

	public ngOnInit() {
		this._emitterService.onCameraSettingsChanged.subscribe(async (args) => {
			if (this.cameraId === args.cameraId) {
				this.camera = await this._simCameraService.getCameraById(this.cameraId);
			}
		});
	}

	public async ngOnChanges(changes: SimpleChanges) {
		if (changes["cameraId"] && changes["cameraId"].currentValue) {
			this.camera = await this._simCameraService.getCameraById(this.cameraId);
		}
	}
}
